import React from "react";

import HexAuthWrapper from "../../components/HexAuthWrapper";
import CheckoutRoute from "../../features/checkout/CheckoutRoute";

const CheckoutPage = () => (
  <div className="checkout-page full-bleed">
    <HexAuthWrapper>
      <CheckoutRoute />
    </HexAuthWrapper>
  </div>
);

export default CheckoutPage;
